module.exports = __webpack_public_path__ + "img/edit.13150108.svg";